import { TextButton } from '@carboncopyco/ui';
import type React from 'react';
import { ImageDropzone, type ImageDropzoneProps } from '../ImageDropzone';

export interface UploadImageButtonProps {
  label?: string;
  disabled?: ImageDropzoneProps['disabled'];
  onUploadSuccess?: ImageDropzoneProps['onSuccess'];
  onUploadError?: ImageDropzoneProps['onError'];
  onUploadLoading?: ImageDropzoneProps['onLoading'];
  triggerComponent?: React.ReactNode;
}

export const UploadImageButton = ({
  label = 'Upload image',
  disabled,
  onUploadLoading,
  onUploadError,
  onUploadSuccess,
  triggerComponent,
}: UploadImageButtonProps) => (
  <ImageDropzone
    disabled={disabled}
    onLoading={onUploadLoading}
    onError={onUploadError}
    onSuccess={onUploadSuccess}
  >
    {triggerComponent ?? (
      <TextButton
        label={label}
        color="text-ds-primary-300"
      />
    )}
  </ImageDropzone>
);
